export default "__VITE_ASSET__D2DHNe1e__"